/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_SubtitleInputs */

const cs_templates_ai_subtitle = /** @type {(inputs: Templates_Ai_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navrhněte bloky z briefu, převeďte markup, importujte soubor nebo zkopírujte styl z jiné šablony.`)
};

const en_templates_ai_subtitle = /** @type {(inputs: Templates_Ai_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft layout blocks from a brief, convert markup, import a file, or copy style from another template.`)
};

/**
* | output |
* | --- |
* | "Draft layout blocks from a brief, convert markup, import a file, or copy style from another template." |
*
* @param {Templates_Ai_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_subtitle = /** @type {((inputs?: Templates_Ai_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_subtitle(inputs)
	return cs_templates_ai_subtitle(inputs)
});